import type { CitationNodeProps } from "@op/richtext-types";
import { Dc_Text_Citation_Trigger_Unsynced } from "@op/sf-op";
import {
  makeCitationDefinitionId,
  makeCitationId,
  useContent,
} from "@op/utils";
import { useMemo } from "react";

const CitationNode = ({ attrs }: CitationNodeProps) => {
  const {
    citations: { content, excursions },
  } = useContent();

  const citations = [
    ...content,
    ...Object.values(excursions).flatMap((e) => e),
  ];

  const citation = useMemo(() => {
    return citations.find((citation) => citation.uniqueId === attrs.uniqueId);
  }, [citations, attrs.uniqueId]);

  if (!citation) return null;
  return (
    <a href={`#${makeCitationDefinitionId(citation.index)}`}>
      <Dc_Text_Citation_Trigger_Unsynced
        className={makeCitationId(citation.index)}
        citationIndex={`[${citation.index}]`}
      />
    </a>
  );
};

export default CitationNode;
